export type NextStep =
  | 'record_token'
  | 'send_memo'
  | 'collect_signatures'
  | 'draft_agreement'
  | 'register'
  | 'collect_brokerage'
  | 'close';

/** The label key and values for the button of a deal's next step. */
export function nextStepLabel(
  step: NextStep,
  memo: { signed: number; total: number } = { signed: 0, total: 3 },
): { key: string; values: Record<string, number> } {
  if (step === 'collect_signatures')
    return {
      key: 'nextStep.collect_signatures',
      values: { signed: memo.signed, total: memo.total },
    };
  return { key: `nextStep.${step}`, values: {} };
}

/** A phone can be dialled only when it is shown in full. A masked number has stars in it. */
export function canCall(phone: string | null | undefined): phone is string {
  return typeof phone === 'string' && phone !== '' && !phone.includes('*');
}

/** The number for a `tel:` link, without spaces. */
export function telHref(phone: string): string {
  return `tel:${phone.replace(/\s+/g, '')}`;
}
